/** Раздел словаря «profile»: профиль игрока, настройки, список розыгрышей, повтор розыгрыша. */
export const profile = {
  // профиль: шапка и вкладки
  loading: 'Загрузка профиля…',
  'crumb.admin': 'Администрирование',
  'crumb.users': 'Пользователи',
  'tab.stats': 'Статистика',
  'tab.games': 'Розыгрыши · {n}',
  'tab.settings': 'Настройки',
  'tag.banned': 'заблокирован',
  'tag.online': 'в сети',
  since: 'С нами с {date} · последняя активность {seen}',
  seenNow: 'сейчас',
  'method.login': 'логин {login}',
  bannedAt: 'Заблокирован {date}',
  bannedAtReason: 'Заблокирован {date}: {reason}',
  balance: 'Баланс',
  ban: 'Заблокировать',
  unban: 'Разблокировать',
  'ban.title': 'Заблокировать {name}',
  'ban.text': 'Игрок будет отключён от игры и не сможет войти. В активном розыгрыше его ход истечёт по тайм-ауту, место освободится после розыгрыша.',
  'ban.reason': 'Причина (видна игроку)',
  'ban.placeholder': 'например, нарушение правил',

  // вкладка «Статистика»
  'stats.summary': 'Итоги',
  'stats.games': 'Розыгрышей',
  'stats.gamesHint': 'из них отменено: {n}',
  'stats.winRate': 'Винрейт',
  'stats.winRateHint': 'доля розыгрышей с выплатой среди состоявшихся',
  'stats.net': 'Итог',
  'stats.netHint': 'сумма чистых результатов, кр.',
  'stats.bestWin': 'Лучший выигрыш',
  'stats.correctDirection': 'Верное направление',
  'stats.avgError': 'Средняя ошибка',
  'stats.avgErrorHint': 'при верном направлении',
  'stats.pointsValue': '{v} п.',
  'stats.folds': 'Пасов',
  'stats.restores': 'Сбросов баланса',
  'stats.restoresHint': 'сколько раз баланс возвращался к стартовому',
  'stats.daily': 'Результат по дням',
  'stats.dailyLabel': 'Чистый результат по дням',
  'stats.dailyNote': 'Последние {n} дн. с игрой. Наведите на столбец, чтобы увидеть сумму.|Последние {n} дн. с игрой. Наведите на столбец, чтобы увидеть сумму.|Последние {n} дн. с игрой. Наведите на столбец, чтобы увидеть сумму.',

  // вкладка «Настройки»
  'settings.visibility': 'Видимость за столом',
  'settings.statsShown': 'Винрейт и итог видны за столом',
  'settings.statsHidden': 'Статистика скрыта',
  'settings.showStats': 'Показывать винрейт и итог на моей плашке',
  'settings.showStatsNote': 'Другие игроки увидят их рядом с вашим именем в списке участников.',
  'settings.winRateTitle': 'винрейт',
  'settings.statsHiddenTag': 'статистика скрыта',
  'settings.name': 'Имя за столом',
  'settings.nameChanged': 'Имя изменено',
  'settings.save': 'Сохранить',
  'settings.nameNote': 'В истории прошлых розыгрышей остаётся имя, с которым вы в них играли.',
  'settings.changePassword': 'Смена пароля',
  'settings.setPassword': 'Вход по логину и паролю',
  'settings.passwordMismatch': 'пароли не совпадают',
  'settings.passwordSaved': 'Пароль сохранён',
  'settings.login': 'Логин',
  'settings.currentPassword': 'Текущий пароль',
  'settings.newPassword': 'Новый пароль',
  'settings.newPasswordAgain': 'Новый пароль ещё раз',
  'settings.savePassword': 'Сохранить пароль',
  'settings.providers': 'Вход через сервисы',
  'settings.noProviders': 'На сервере не настроен вход через внешние сервисы.',
  'settings.linkedSince': 'с {date}',
  'settings.unlinked': 'Сервис отвязан',
  'settings.unlink': 'Отвязать',
  'settings.notLinked': 'не привязан',
  'settings.link': 'Привязать',

  // сброс баланса
  'reset.button': 'Сбросить баланс',
  'reset.already': 'баланс уже стартовый',
  'reset.title': 'Сбросить баланс',
  'reset.titleFor': 'Сбросить баланс: {name}',
  'reset.confirm': 'Сбросить до {amount|cr}',
  'reset.textBefore': 'Баланс станет',
  'reset.textNow': '(сейчас',
  'reset.textAfter': '). Статистика и история розыгрышей сохранятся. Во время розыгрыша сброс недоступен.',
  'reset.done': 'Баланс сброшен: {amount|cr}',

  // список розыгрышей
  'kind.market': 'рынок',
  'kind.walkover': 'остался один',
  'kind.cancel': 'отмена',
  'games.emptyPlayer': 'Розыгрышей пока нет — сядьте за стол в лобби.',
  'games.emptyAdmin': 'Розыгрышей пока не было.',
  'games.historyTag': 'история',
  'games.error': 'ошибка {v}',
  'games.replay': 'Как шла игра',
  'col.time': 'Время',
  'col.table': 'Стол',
  'col.composition': 'Состав',
  'col.forecast': 'Прогноз',
  'col.contributed': 'Внесено',
  'col.net': 'Итог',
  'col.players': 'Игроки',
  'col.pot': 'Банк',
  'col.commission': 'Комиссия',
  'col.player': 'Игрок',
  'col.error': 'Ошибка',
  'col.payout': 'Выплата',

  // повтор розыгрыша
  'replay.loading': 'Загрузка записи розыгрыша…',
  'replay.crumbAdmin': 'Розыгрыши площадки',
  'replay.crumbProfile': 'Профиль',
  'replay.crumbGame': 'Розыгрыш {id}',
  'replay.title': 'Стол {ante|cr} · {date}',
  'replay.modeReplay': 'воспроизведение истории',
  'replay.modeLive': 'реальное время',
  'replay.sourceSynthetic': 'синтетические данные',
  'replay.seats': '{n} участник|{n} участника|{n} участников',
  'replay.result': 'Итог',
  'replay.resultCancelled': 'отменён',
  'replay.resultWalkover': 'остался один',
  'replay.resultSettled': 'расчёт',
  'replay.pot': 'Банк',
  'replay.legacy': 'Запись перенесена из журнала прежней версии: хронология ходов и график не сохранялись, доступен только расчёт.',
  'replay.toStart': 'В начало',
  'replay.stepBack': 'Шаг назад',
  'replay.pause': 'Пауза',
  'replay.play': 'Воспроизвести',
  'replay.stepForward': 'Шаг вперёд',
  'replay.toEnd': 'В конец',
  'replay.position': 'Момент записи',
  'replay.stageSettled': 'Расчёт выполнен',
  'replay.stagePrep': 'Подготовка: взносы вносятся в банк',
  'replay.participants': 'Участники',
  'replay.you': 'вы',
  'replay.returned': 'возврат {amount}',
  'replay.noteNet': 'Справа — чистый результат.',
  'replay.noteContributed': 'Справа — внесено в банк к этому моменту.',
  'replay.noteAdmin': 'Прогнозы видны администратору.',
  'replay.notePlayer': 'Чужие прогнозы видны в расчёте.',
  'replay.composition': 'Состав',
  'replay.compositionHidden': 'раскрывается в круге 3',
  'replay.timeline': 'Хронология',
  'replay.settlement': 'Расчёт',
  'replay.summary': 'P₀ {p0} → P₁ {p1}; комиссия {commission|cr}.',
  'replay.verify': 'Проверить в браузере',
  'replay.download': 'Скачать пакет проверки',
  'replay.roundPrep': 'подготовка',
  'replay.round': 'круг {n}',
  // ── проверка файла пакета (перенесена из лобби в 0.8.2) ──
  'verify.title': 'Проверка розыгрыша',
  'verify.textBefore': 'После каждого розыгрыша участник может скачать подписанный пакет: все ходы, состав и исходные котировки акций, расчёт и проводки. Его можно проверить здесь или утилитой',
  'verify.textAfter': 'и сравнить котировки с любым внешним источником.',
  'verify.button': 'Проверить файл пакета…',
};
